import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Logo from "../assets/logo_lite.png";
import { authService } from "../services/auth.service";

type NavbarProps = {
  onToggleSidebar: () => void;
};

const Navbar: React.FC<NavbarProps> = ({ onToggleSidebar }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleChangePassword = async () => {
    if (oldPassword && newPassword && confirmPassword) {
      if (newPassword !== confirmPassword) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: "New password and confirm password do not match",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      try {
        await authService.changePassword({
          current_password: oldPassword,
          new_password: newPassword,
          confirm_password: confirmPassword,
        });
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          text: "Password changed successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
        setShowModal(false);
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } catch (error) {
        console.error("Failed to change password:", error);
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: "Failed to change password",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } else {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "warning",
        text: "All fields are required",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const handleLogout = async () => {
    try {
      await authService.logout();
      localStorage.removeItem("authToken");
      navigate("/");
    } catch (error) {
      console.error("Failed to logout:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to logout",
        text: "Please try again.",
      });
    }
  };

  return (
    <>
      <div className="topbar">
        <div
          className="topbar-left"
          style={{
            background: "#a3ddbf",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Link
            to="/dashboard"
            className="logo"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <img
              src={Logo}
              alt="Logo"
              style={{
                width: "70%",
                maxHeight: "70px",
                objectFit: "contain",
              }}
            />
          </Link>
        </div>

        <nav className="navbar-custom">
          <ul className="list-inline menu-left mb-0">
            <li className="float-left">
              <button
                className="button-menu-mobile open-left waves-light waves-effect"
                onClick={onToggleSidebar}
              >
                <i className="zmdi zmdi-menu"></i>
              </button>
            </li>
            <li className="hidden-mobile app-search"></li>
            <li className="float-right">
              <button
                type="button"
                className="btn btn-outline-warning me-2"
                onClick={() => setShowModal(true)}
              >
                PASSWORD
              </button>
              <button
                type="button"
                className="btn btn-outline-warning"
                onClick={handleLogout}
              >
                LOGOUT
              </button>
            </li>
          </ul>
        </nav>
      </div>

      {/* Modal untuk Change Password */}
      {showModal && (
        <div className="modal" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Change Password</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="oldPassword" className="form-label">
                    Current Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="oldPassword"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="newPassword" className="form-label">
                    New Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="confirmPassword" className="form-label">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleChangePassword}
                >
                  Change Password
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
